function is_phone_validated(number) {
  return number.length === 11 && /^[0۰][0-9۰-۹]+$/.test(number);
}

export { is_phone_validated };
